import React, { Component } from 'react';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  FilterSettingsModel,
  Freeze,
  GridComponent,
  Inject,
  Page,
  Reorder,
  Resize,
  VirtualScroll,
} from '@syncfusion/ej2-react-grids';
import { FaAngleDown, FaAngleRight, FaAngleUp } from 'react-icons/fa';
import moment from 'moment';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { FcNext, FcPrevious } from 'react-icons/fc';
import { ThemeContext } from '../../context/theme.context';
import Message from '../../utils/Message/Message';
import { TreeViewComponent } from '@syncfusion/ej2-react-navigations';
import '../CloudScheduler/gantt.css';
import { FiAlertTriangle } from 'react-icons/fi';
import { GetSchedulerLoad } from '../../services/CloudScheduler/CloudSchedulerServices';
import { Tooltip } from '@syncfusion/ej2-react-popups';
import { QueryCellInfoEventArgs } from '@syncfusion/ej2-grids';
import {
  ButtonComponent,
  ChipDirective,
  ChipListComponent,
  ChipsDirective,
} from '@syncfusion/ej2-react-buttons';
import {
  DropDownListComponent,
  ChangeEventArgs,
} from '@syncfusion/ej2-react-dropdowns';
import { loadingShow } from '../../App';
import { CloudScheduler } from './CloudScheduler';
import { RootState } from '../../store';
import { connect } from 'react-redux';
import { setCloudSchedularGantDataChanged } from '../../redux/search.slice';
import SchedulerTabBar from "./SchedulerTabBar";

const SHIFT_DAY = 'DS';
const SHIFT_NIGHT = 'NS';
const SHIFT_UNASSIGNED = 'UNASSIGNED';

type ShiftViewMode = 'default' | 'day' | 'night' | 'all' | 'all_no_total';

interface IProps {
  cloudSchedularGantDataChanged: boolean;
  setCloudSchedularGantDataChanged: (value: boolean) => void;
  isLoad: boolean;
  queryForLoad: string;
  handleDatePickerChange: (args: Date, weekCount: number) => void;
  fitInGant: (args: Date) => void;
  refreshToken: string;
}
interface CellData {
  resourceDescription: string;
}
interface IState {
  currentIcon: any;
  status: boolean;
  allowRender: boolean;
  loadGant: Array<any>;
  columnDate: Array<any>;
  datePickerValue: Date;
  fields: any;
  expandableButton: boolean;
  isLoad: boolean;
  shiftViewMode: ShiftViewMode;
  expandedTrades: Set<string>;
}
class Load extends Component<IProps, IState> {
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  private tooltip: Tooltip | null = null;

  public localStorageCloudSchedularDate = localStorage.getItem(
      'CloudSchedularLastFilteredDate'
  );
  public localStorageShiftViewMode = localStorage.getItem(
    'CloudSchedularShiftViewMode'
) as ShiftViewMode | null;

  private theLoadGrid: GridComponent;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private DPC: DatePickerComponent;
  public treeObj: TreeViewComponent;
  private isRenderAllow: boolean = false;
  private theCurrentDateField: Array<any> = [];
  private theInitialDate: Date = new Date();
  private weekCount: number = 1;
  private isDateChangeRequest = false;

private shiftViewOptions: Array<{ text: string; value: ShiftViewMode }> = [
  { text: 'Default', value: 'default' },
  { text: 'Day Shift', value: 'day' },
  { text: 'Night Shift', value: 'night' },
  { text: 'All Shifts', value: 'all_no_total' },
  { text: 'All Shifts + Total', value: 'all' },
];

  constructor(prop: IProps) {
    super(prop);
    const isLoad = this.props.isLoad;
    this.theLoadGrid = new GridComponent({});
    this.treeObj = new TreeViewComponent({});
    this.state = {
      currentIcon: <FaAngleDown size='14px' />,
      loadGant: [],
      status: false,
      columnDate: [],
      allowRender: false,
      datePickerValue: this.localStorageCloudSchedularDate
          ? JSON.parse(this.localStorageCloudSchedularDate)
          : CloudScheduler.start_date,
      fields: {
        dataSource: [],
        id: '',
        parentID: '',
        text: '',
        hasChildren: '',
      },
      expandableButton: true,
      isLoad: isLoad,
      shiftViewMode: this.localStorageShiftViewMode || 'default',
      expandedTrades: new Set<string>(),
    };
    this.DPC = new DatePickerComponent({});
  }
  private theWeekOfDay = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  private rawTradeData: Array<any> = [];
  private rawPersonData: Array<any> = [];
  dateGenerator(start_date: Date, weekNumber: number) {
    var theDateObject: Array<any> = [];
    var theDate: Date = new Date(start_date);
    for (var i = 0; i < weekNumber * 7; i++) {
      theDateObject.push({
        field: moment(theDate).format('yyy-MM-DD'),
        dayName:
            this.theWeekOfDay[moment(theDate).toDate().getDay()] +
            '  ' +
            moment(theDate).toDate().getDate() +
            '/' +
            (moment(theDate).toDate().getMonth() + 1) +
            '/' +
            moment(theDate).toDate().getFullYear(),
      });
      theDate.setDate(theDate.getDate() + 1);
    }
    return theDateObject;
  }
  async componentDidUpdate(
      prevProps: Readonly<IProps>,
      prevState: Readonly<IState>,
      snapshot?: any
  ): Promise<void> {
    if (prevProps.refreshToken !== this.props.refreshToken) {
      if (this.props.refreshToken !== '') {
        await this.getCapacity(this.props.queryForLoad);
      }
    }
    if (prevProps.queryForLoad !== this.props.queryForLoad &&  this.isRenderAllow) {
      await this.getCapacity(this.props.queryForLoad);
      this.reCreateGridColumn(this.DPC.value, this.weekCount);
    }
    if (this.context.isLoadAllowChange) {
      this.isRenderAllow = true;
      if (this.isDateChangeRequest) {
        this.theInitialDate = new Date(CloudScheduler.start_date);
        this.setState({
          datePickerValue: CloudScheduler.start_date,
          expandableButton: !this.context.isLoadAllowChange,
        });
        var date = CloudScheduler.start_date;
        this.DPC.value = date;
        this.reCreateGridColumn(this.DPC.value, this.weekCount);
      }
      this.context.setLoadAllowChange(false);
    }
    if (
        prevProps.cloudSchedularGantDataChanged !==
        this.props.cloudSchedularGantDataChanged
    ) {
      loadingShow(true);
      await this.getCapacity(this.props.queryForLoad);
      this.props.setCloudSchedularGantDataChanged(false);
    }
  }
  expand = () => {
    var element = document.getElementById('expandable');
    if (this.state.status) {
      element?.classList.remove('layoutExpand');
      element?.classList.add('layoutCollapse');
      // this.setState({ currentIcon: <FaAngleDown size='14px' /> });
    } else {
      element?.classList.remove('layoutCollapse');
      element?.classList.add('layoutExpand');
      // this.setState({ currentIcon: <FaAngleUp size='14px' /> })
    }
    this.setState({
      status: !this.state.status,
      currentIcon: this.state.status ? (
          <FaAngleDown size='14px' />
      ) : (
          <FaAngleUp size='14px' />
      ),
      allowRender: true,
    });
  };
  componentDidMount() {
    this.handlerOfFitGant();
  }
  componentWillUnmount(): void {
    this.isRenderAllow = false;
  }
  async getCapacity(range: string) {
    let planIdsToUse: string | number = this.context?.planId?.toString() || '-1';
    const planIdsStr = localStorage.getItem('cs_plan_dd_values');
    if (planIdsStr) {
      try {
        const planIds = JSON.parse(planIdsStr);
        if (Array.isArray(planIds) && planIds.length > 0) {
          planIdsToUse = planIds.join(',');
        }
      } catch (e) {
      }
    }

    if (planIdsToUse && planIdsToUse !== '-1' && planIdsToUse !== '') {
      let parts = range.split('$');
      if (parts.length > 2) {
        parts[2] = planIdsToUse.toString();
        range = parts.join('$');
      }
    }
    // if (CloudScheduler.tradeExchangeIds !== '') {
    //   range = range.replace(
    //     `$${CloudScheduler.tradeExchangeIds}`,
    //     `$$${CloudScheduler.tradeExchangeText}`
    //   );
    // }
    await GetSchedulerLoad(range)
        .then((res) => res.json())
        .then((response) => {
          loadingShow(false);

        const tradeMap = new Map<string, any>();
        const personMap = new Map<string, any>();

        const mergeBucket = (target: any, dayKey: string, shiftBucketKey: string, el: any) => {
              if (target[`${dayKey}data`]) {
                target[`${dayKey}data`].load += el.load;
                target[`${dayKey}data`].capacity += el.capacity;
              } else {
                target[`${dayKey}`] = dayKey;
                target[`${dayKey}data`] = { ...el };
              }
              if (target[`${shiftBucketKey}data`]) {
                target[`${shiftBucketKey}data`].load += el.load;
                target[`${shiftBucketKey}data`].capacity += el.capacity;
              } else {
                target[`${shiftBucketKey}`] = shiftBucketKey;
                target[`${shiftBucketKey}data`] = { ...el };
              }
            };

      if (Array.isArray(response) && response.length > 0) {
        response.forEach((el: any) => {
          const shiftKey =
            el.element_alias_value === SHIFT_DAY || el.element_alias_value === SHIFT_NIGHT
              ? el.element_alias_value
              : SHIFT_UNASSIGNED;
          const dayKey = el.dayName;
          const shiftBucketKey = `${dayKey}_${shiftKey}`;

          if (el.isPerson) {
            const tradeCode = (el.parentTradeCode || '').trim();
            const personLabel = el.resourceName;
            const personKey = `${tradeCode}::${personLabel}`;
            let target = personMap.get(personKey);
            if (!target) {
              target = {
                resourceName: personLabel,
                personName: personLabel, 
                resourceDescription: el.resourceDescription,
                parentTradeCode: tradeCode,
              };
              personMap.set(personKey, target);
            }
            mergeBucket(target, dayKey, shiftBucketKey, el);
          } else {
            const tradeCode = (el.resourceName || '').trim();
            let target = tradeMap.get(tradeCode);
            if (!target) {
              target = { resourceName: tradeCode, resourceDescription: el.resourceDescription };
              tradeMap.set(tradeCode, target);
            }
            mergeBucket(target, dayKey, shiftBucketKey, el);
              }
            });
          }

      personMap.forEach((personRow) => {
        const tradeRow = tradeMap.get(personRow.parentTradeCode);
        if (!tradeRow) return;
        Object.keys(tradeRow).forEach((key) => {
          if (!key.endsWith('data')) return;
          const tradeBucket = tradeRow[key];
          if (personRow[key]) {
            personRow[key].capacity = tradeBucket.capacity;
          } else {
            personRow[key] = { ...tradeBucket, load: 0 };
            const baseKey = key.replace(/data$/, '');
            personRow[baseKey] = tradeRow[baseKey];
          }
        });
        
      });

      this.rawTradeData = Array.from(tradeMap.values());
      this.rawPersonData = Array.from(personMap.values());

          if (this.isRenderAllow) {
            this.setState({ loadGant: this.buildFlatRows() });
          }
        })
        .catch((e) => {
          loadingShow(false);
          Message.error('Something went wrong!!!. Code:Load-175');
          console.log(e);
        });
  }
buildFlatRows = (expandedTrades: Set<string> = this.state.expandedTrades): Array<any> => {
  const flat: Array<any> = [];
  this.rawTradeData.forEach((trade) => {
    const tradePersons = this.rawPersonData.filter(
      (p) => p.parentTradeCode === trade.resourceName
    );
    flat.push({ ...trade, rowType: 'trade', hasPersons: tradePersons.length > 0 });
    if (expandedTrades.has(trade.resourceName)) {
      const persons = [...tradePersons].sort((a, b) =>
        String(a.resourceName).localeCompare(String(b.resourceName))
      );
      persons.forEach((p) => flat.push({ ...p, rowType: 'person' }));
    }
  });
  return flat;
};


private _pendingLoadScrollRestore: number | null = null;

private captureLoadGridScroll = () => {
  const contentEl = this.theLoadGrid?.getContent?.()?.firstElementChild as HTMLElement | undefined;
  this._pendingLoadScrollRestore = contentEl ? contentEl.scrollTop : null;
};

toggleTradeExpand = (tradeCode: string) => {
  const hasPersons = this.rawPersonData.some((p) => p.parentTradeCode === tradeCode);
  if (!hasPersons) return;

  this.captureLoadGridScroll();

  const next = new Set(this.state.expandedTrades);
  next.has(tradeCode) ? next.delete(tradeCode) : next.add(tradeCode);

  this.setState({ expandedTrades: next, loadGant: this.buildFlatRows(next) });
};
resourceNameTemplate = (rowData: any) => {
  const isTrade = rowData.rowType === 'trade';
  const isExpanded = isTrade && this.state.expandedTrades.has(rowData.resourceName);
  const canExpand = isTrade && !!rowData.hasPersons;

  if (!isTrade) {
    return <div></div>;
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginLeft: '2px',
        cursor: canExpand ? 'pointer' : 'default',
      }}
      onClick={canExpand ? () => this.toggleTradeExpand(rowData.resourceName) : undefined}
    >
      <span style={{ marginRight: 6, width: 12, display: 'inline-flex', flexShrink: 0 }}>
        {canExpand ? (
          isExpanded ? <FaAngleDown size='12px' /> : <FaAngleRight size='12px' />
        ) : null}
      </span>
      <span>{rowData.resourceName}</span>
    </div>
  );
};
resourceOrPersonTemplate = (rowData: any) => {
  const isTrade = rowData.rowType === 'trade';

  if (isTrade) {
    const isExpanded = this.state.expandedTrades.has(rowData.resourceName);
    const canExpand = !!rowData.hasPersons;

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          marginLeft: '2px',
          fontWeight: '800',
          cursor: canExpand ? 'pointer' : 'default',
        }}
        onClick={canExpand ? () => this.toggleTradeExpand(rowData.resourceName) : undefined}
      >
        <span style={{ marginRight: 6, width: 12, display: 'inline-flex', flexShrink: 0 }}>
          {canExpand ? (
            isExpanded ? <FaAngleDown size='12px' /> : <FaAngleRight size='12px' />
          ) : null}
        </span>
        <span>{rowData.resourceName}</span>
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'start', fontSize: '12px', marginLeft: '6px' }}>
      {rowData.personName}
    </div>
  );
};
tradePersonTemplate = (rowData: any) => {
  if (rowData.rowType !== 'person') {
    return <div></div>;
  }
  return (
    <div style={{ textAlign: 'start', fontSize: '12px', marginLeft: '6px' }}>
      {rowData.personName}
    </div>
  );
};
handleLoadRowDataBound = (args: any) => {
  const row = args.row as HTMLElement;
  const data = args.data as any;
  if (!row) return;
  if (data?.rowType === 'person') {
    row.classList.add('load-grid-person-row');
  } else if (data?.rowType === 'trade') {
    row.classList.add('load-grid-trade-row');
  }
};
  ConvertToDate(val: any) {
    var num = parseInt(val.substring(6, 19));
    var date = moment(num).format('yyyy-MM-DD');
    return date;
  }

  dataTemplate(args: string, comming: any) {
    var cond = comming[args];
    let current_content = <div></div>;
    if (cond) {
      var numberCapacity = Number(comming[`${cond}data`].capacity);
      var numberLoad = Number(comming[`${cond}data`].load);
      var theBackGroundColor = '';
      var theTextColor = '';
      var theResult = 0;

      const isShift = this.state.shiftViewMode !== 'default';
      const cellPadding = isShift ? 2 : 5;
      const cellMarginRight = isShift ? 2 : 5;
      const gridpadding = isShift ? 2 : 5;
      const fontsize = isShift ? '13px' : '14px';
      const contentMarginRight = isShift ? '1px' : '3px';

      if (numberCapacity !== 0) {
        theResult = isShift
          ? Math.round((numberLoad / numberCapacity) * 100)
          : Number(((numberLoad / numberCapacity) * 100).toFixed(2));
      }
      current_content = <div>{theResult}%</div>;
      if (theResult < 79) {
        theBackGroundColor = '#0d6efd';
        theTextColor = 'var(--dark-text)';
      } else if (theResult > 80 && theResult <= 100) {
        theBackGroundColor = '#008000';
        theTextColor = 'var(--dark-text)';
      } else if (theResult < 100 || theResult > 100) {
        theBackGroundColor = '#C90016';
        theTextColor = 'white';
      }
      if (theResult === Infinity) {
        current_content = (
            <div>
              <FiAlertTriangle size={25} />
            </div>
        );
      }
      let theLoad = comming[`${cond}data`].load;
      let theCapacity = comming[`${cond}data`].capacity;
      if (isNaN(theLoad)) {
        theLoad = 0;
      }
      if (isNaN(theCapacity)) {
        theCapacity = 0;
      }
      return (
          <div
              style={{
                display: 'grid',
                gridTemplateColumns: '32% 32% 36%',
                alignItems: 'center',
                padding: gridpadding,
                paddingRight: 0,
                paddingLeft: 0,
                borderRadius: 5,
                color: theTextColor,
                fontSize: fontsize,
              }}
              className='animation'
          >
            <div
                style={{
                  padding: cellPadding,
                  marginRight: cellMarginRight,
                  borderRadius: 5,
                  backgroundColor: '#F4B400',
                  color: 'black',
                  height: '100%',
                  paddingRight: 0,
                  paddingLeft: 0,
                  textAlign: "center"
                }}
            >
               {isShift ? Math.round(theLoad) : theLoad?.toFixed(2)}
            </div>
            <div
                style={{
                  marginRight: cellMarginRight,
                  padding: cellPadding,
                  borderRadius: 5,
                  backgroundColor: '#36454F',
                  textAlign: 'center',
                  color: 'white',
                  height: '100%',
                  paddingRight: 0,
                  paddingLeft: 0,
                }}
            >
               {isShift ? Math.round(theCapacity) : theCapacity?.toFixed(2)}
            </div>
            <div
                style={{
                  padding: cellPadding,
                  borderRadius: 5,
                  paddingRight: contentMarginRight,
                  paddingLeft: 0,
                  backgroundColor:
                      Number(numberCapacity) === 0 ? '#C90016' : theBackGroundColor,
                  textAlign: 'right',
                  color: 'white',
                }}
            >
              {current_content}
            </div>
          </div>
      );
    } else {
      return <div></div>;
    }
  }
  dataTemplateShiftTotal = (args: string, comming: any) => {
    var cond = comming[args];
    if (!cond) return <div></div>;

    var numberCapacity = Number(comming[`${cond}data`].capacity);
    var numberLoad = Number(comming[`${cond}data`].load);
    var theResult = 0;
    var thePercentColor = '';

    if (numberCapacity !== 0) {
      theResult = Math.round((numberLoad / numberCapacity) * 100);
    }
    if (Number(numberCapacity) === 0) {
      thePercentColor = '#ED4250';
    } else if (theResult < 79) {
      thePercentColor = '#36A4FF';
    } else if (theResult > 80 && theResult <= 100) {
      thePercentColor = '#09E009';
    } else {
      thePercentColor = '#ED4250';
    }

    let theLoad = comming[`${cond}data`].load;
    let theCapacity = numberCapacity;
    if (isNaN(theLoad)) theLoad = 0;
    if (isNaN(theCapacity)) theCapacity = 0;

    if (theResult === Infinity) {
      return (
          <div style={{ textAlign: 'center' }}>
            <FiAlertTriangle size={18} />
          </div>
      );
    }

    return (
        <div
            style={{
              textAlign: 'center',
              fontSize: '13px',
              fontWeight: 500,
              whiteSpace: 'nowrap',
            }}
        >
          <span style={{ color: '#F4B400' }}>{Math.round(theLoad)}</span>
          <span style={{ color: '#dcdcdc' }}>/</span>
          <span style={{ color: '#A6BFDE' }}>{Math.round(theCapacity)}</span>
          <span style={{ color: '#dcdcdc' }}>-</span>
          <span style={{ color: thePercentColor }}>{theResult}%</span>
        </div>
    );
  };
dataTemplateShiftColumn = (dayField: string, shiftKey: string, comming: any) => {
  const hasAnyRealShiftForDay =
      !!comming[`${dayField}_${SHIFT_DAY}`] || !!comming[`${dayField}_${SHIFT_NIGHT}`];

  if (!hasAnyRealShiftForDay) {
    const isAllVariant = this.state.shiftViewMode === 'all' || this.state.shiftViewMode === 'all_no_total';
    if (isAllVariant && shiftKey === SHIFT_DAY) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <div style={{ width: '100%'}}>
            {this.dataTemplate(dayField, comming)}
          </div>
        </div>
      );
    }
    return <div></div>;
  }

  return this.dataTemplate(`${dayField}_${shiftKey}`, comming);
};
handleShiftCellMerge = (args: any): void => {
  const isAllVariant = this.state.shiftViewMode === 'all' || this.state.shiftViewMode === 'all_no_total';
  if (!isAllVariant) return;
  const field: string = args.column?.field;
  if (!field) return;
  const match = field.match(/^(.*)_(DS|NS)$/);
  if (!match) return;
  const [, dayField, shiftKey] = match;
  const rowData: any = args.data;
  const hasAnyRealShiftForDay =
      !!rowData?.[`${dayField}_${SHIFT_DAY}`] || !!rowData?.[`${dayField}_${SHIFT_NIGHT}`];

  const cell = args.cell as HTMLElement;
  if (!cell) return;

  if (shiftKey === SHIFT_DAY) {
    if (!hasAnyRealShiftForDay) {
      cell.setAttribute('colspan', '2');
    } else {
      cell.removeAttribute('colspan');
    }
  } else if (shiftKey === SHIFT_NIGHT) {
    cell.style.display = hasAnyRealShiftForDay ? '' : 'none';
  }
};

  handleQueryCellInfo = (args: QueryCellInfoEventArgs): void => {
    // if (this.tooltip) {
    //   this.tooltip.destroy();
    //   this.tooltip = null;
    // }
    // Create tooltip for the cell
    if (args.data && 'resourceDescription' in args.data) {
      const data = args.data as CellData;
      this.tooltip = new Tooltip({
        content: data.resourceDescription,
        position: 'TopCenter',
        opensOn: 'Hover',
        closeDelay: 100,
      });
      this.tooltip.appendTo(args.cell as HTMLElement);
    } else {
      console.warn('Resource description is not available.');
    }
  };
  dataCapacityTemplate(args: any) {
    let totalCapacity = 0;
    let totalLoad = 0;
    totalCapacity = 0;
    let current_content = <div></div>;
    var theResult = 0;
    var theBackGroundColor = '';
    var theTextColor = '';

    const isShift = this.state.shiftViewMode !== 'default';
    const cellPadding = isShift ? 2 : 5;
    const gridColumns = isShift
        ? '32% 1% 32% 1% 34%'
        : '26% 4% 27% 4% 39%';

    this.theCurrentDateField.map((theDate) => {
      let theCurrent = args[`${theDate.field}data`];

      if (theCurrent) {
        totalCapacity += theCurrent.capacity;
        totalLoad += theCurrent.load;
      }
    });
    if (totalCapacity !== 0) {
      theResult = isShift
        ? Math.round((totalLoad / totalCapacity) * 100)
        : Number(((totalLoad / totalCapacity) * 100).toFixed(2));
    }
    if (theResult < 80) {
      theBackGroundColor = '#0d6efd';
      theTextColor = 'var(--dark-text)';
    } else if (theResult >= 80 && theResult <= 100) {
      theBackGroundColor = '#008000';
      theTextColor = 'var(--dark-text)';
    } else if (theResult > 100) {
      theBackGroundColor = '#C90016';
      theTextColor = 'white';
    }
    current_content = <span>{theResult}%</span>;
    return (
        <div
            style={{
              display: 'grid',
              gridTemplateColumns: gridColumns,
              alignItems: 'center',
              padding: 5,
              paddingRight: 0,
              paddingLeft: 0,
              borderRadius: 5,
            }}
        >
          <div
              style={{
                backgroundColor: '#F4B400',
                borderRadius: 5,
                height: '100%',
                padding: cellPadding,
                paddingRight: 0,
                paddingLeft: 0,
                textAlign: "center"
              }}
          >
            <span style={{ color: 'black' }}>{totalLoad}</span>
          </div>
          <div style={{ textAlign: "center"}}>
            <span></span>
          </div>
          <div
              style={{
                backgroundColor: '#36454F',
                borderRadius: 5,
                height: '100%',
                padding: cellPadding,
                paddingRight: 0,
                paddingLeft: 0,
                textAlign: 'center'
              }}
          >
            <span style={{}}>{totalCapacity}</span>
          </div>
          <div style={{ textAlign: "center"}}>
            <span></span>
          </div>
          <div
              style={{
                padding: cellPadding,
                paddingRight: 3,
                paddingLeft: 3,
                borderRadius: 5,
                backgroundColor:
                    Number(totalCapacity) === 0 ? '#C90016' : theBackGroundColor,
                textAlign: 'right',
                color: 'white',
              }}
          >
            {current_content}
          </div>
        </div>
    );
  }
  datePickerOnChange(args: any) {
    const originalDate = new Date(args.value);
    originalDate.setHours(10, 0, 0, 0);
    CloudScheduler.start_date = originalDate;
    localStorage.setItem(
        'CloudSchedularLastFilteredDate',
        JSON.stringify(args.value)
    );

    this.props.handleDatePickerChange(originalDate, this.weekCount);
    this.reCreateGridColumn(originalDate, this.weekCount);
  }
  private buildDayColumn(el: any, Dayname: string): any {
  const weekendColor = Dayname === 'Sat' || Dayname === 'Sun' ? '#20CAE5' : '';
  const mode = this.state.shiftViewMode;
  const isAllVariant = mode === 'all' || mode === 'all_no_total';

  if (mode === 'default') {
    return {
      field: el.field,
      headerText: el.dayName,
      template: this.dataTemplate.bind(this, el.field),
      width: 200,
      textAlign: 'Center',
      customAttributes: { style: { color: weekendColor } },
    };
  }

  const shiftColumns: any[] = [];

  if (isAllVariant || mode === 'day') {
    shiftColumns.push({
      field: `${el.field}_${SHIFT_DAY}`,
      headerText: 'Day Shift',
      template: this.dataTemplateShiftColumn.bind(this, el.field, SHIFT_DAY),
      width: isAllVariant ? (mode === 'all_no_total' ? 146 : 102) : 146,
    });
  }

  if (isAllVariant || mode === 'night') {
    shiftColumns.push({
      field: `${el.field}_${SHIFT_NIGHT}`,
      headerText: 'Night Shift',
      template: this.dataTemplateShiftColumn.bind(this, el.field, SHIFT_NIGHT),
      width: isAllVariant ? (mode === 'all_no_total' ? 145 : 101) : 146,
    });
  }

  if (mode !== 'all_no_total') {
    shiftColumns.push({
      field: el.field,
      headerText: 'Total',
      template:
          mode === 'all'
              ? this.dataTemplateShiftTotal.bind(this, el.field)
              : this.dataTemplate.bind(this, el.field),
      width: mode === 'all' ? 92 : 145,
    });
  }

  return {
    headerText: el.dayName,
    textAlign: 'Center',
    customAttributes: { style: { color: weekendColor } },
    columns: shiftColumns,
  };
}
reCreateGridColumn = (date: Date, selectedWeek: number) => {
    var theDate: Date = new Date(date);
    this.theCurrentDateField = this.dateGenerator(date, selectedWeek);
    var theArray: any[] = [
      {
        field: 'resourceName',
        headerText: 'Trade',
        width: 110,
        freeze: 'Left',
        textAlign: 'Center',
        template: this.resourceOrPersonTemplate.bind(this),
      },
      /* {
        field: 'personName',
        headerText: 'TradesPerson',
        width: 110,
        freeze: 'Left',
        textAlign: 'Center',
        template: this.tradePersonTemplate.bind(this),
      }, */
      ...this.theCurrentDateField.map((el) => {
        const [Dayname] = el.dayName.split(' ');
        return this.buildDayColumn(el, Dayname);
      }),
    ];
    const totalCapacityWidth =
        this.state.shiftViewMode === 'default'
            ? 212
            : this.state.shiftViewMode === 'all'
                ? 122
                : 150;
    theArray.push({
      field: 'totalCapacity',
      headerText: 'T. Load - T. Capacity-%',
      template: this.dataCapacityTemplate.bind(this),
      width: totalCapacityWidth,
      freeze: 'Right',
      textAlign: 'Center',
      customAttributes: { style: { color: '#20CAE5' } },
    });
    if (this.theLoadGrid) {
      this.theLoadGrid.frozenColumns = 1;
      this.theLoadGrid.columns = theArray as any;
      this.theLoadGrid.refreshColumns();
    }
    if (this.theLoadGrid) {
  this.theLoadGrid.headerCellInfo = (args: any) => {
    const field: string = args.cell?.column?.field;
    const headerText: string = args.cell?.column?.headerText;

    if (field) {
      if (field.endsWith(`_${SHIFT_DAY}`)) {
        args.node.style.backgroundColor = '#22d3ee';
        args.node.style.color = '#111111';
      } else if (field.endsWith(`_${SHIFT_NIGHT}`)) {
        args.node.style.backgroundColor = '#666666';
        args.node.style.color = '#fff';
      }
    }

    if (headerText === 'Total') {
      args.node.style.backgroundColor = '#15202b';
      args.node.style.color = '#dcdcdc';
    }

    if (this.state.shiftViewMode !== 'default') {
      args.node.style.height = '18px';
      const headerTextEl = args.node.querySelector('.e-headertext');
      if (headerTextEl) {
        (headerTextEl as HTMLElement).style.lineHeight = '18px';
        (headerTextEl as HTMLElement).style.height = '18px';
      }
    }
        args.node.addEventListener("click", () => {
          const clickedField = args.cell.column.field;
          if (!clickedField) return;
          const datePart = clickedField.split('_')[0].split(' ')[0];
          const parsedDate = new Date(datePart);
          if (isNaN(parsedDate.getTime())) {
            return;
          }
          this.context.setQuickScheduleDateOnLoad(datePart);
          this.context.setIsClickedQuickLoad(true);
        });

      };
    }
  };
  previousWeekButton() {
    var theCurrentDate = new Date(this.DPC.value);
    theCurrentDate.setDate(theCurrentDate.getDate() - this.weekCount * 7);
    this.props.handleDatePickerChange(new Date(theCurrentDate), this.weekCount);
    this.DPC.value = theCurrentDate;
    localStorage.setItem('load_start_date', theCurrentDate.toString());
    this.DPC.refresh();
    this.reCreateGridColumn(theCurrentDate, this.weekCount);
  }
  nextWeekButton() {
    var theCurrentDate = new Date(this.DPC.value);
    theCurrentDate.setDate(theCurrentDate.getDate() + this.weekCount * 7);
    this.props.handleDatePickerChange(new Date(theCurrentDate), this.weekCount);
    this.DPC.value = theCurrentDate;
    localStorage.setItem('load_start_date', theCurrentDate.toString());
    this.DPC.refresh();
    this.reCreateGridColumn(theCurrentDate, this.weekCount);
  }
  componentCreated() {
    this.reCreateGridColumn(CloudScheduler.start_date, this.weekCount);
  }
  handlerOfFitGant() {
    this.DPC.value = this.theInitialDate;
    this.reCreateGridColumn(this.DPC.value, this.weekCount);
    this.props.fitInGant(CloudScheduler.start_date);
  }
  handleToChangeWeekNumber(args: any) {
    if (this.weekCount !== args.data.value) {
      this.weekCount = args.data.value;
      this.DPC.value = this.theInitialDate;
      this.props.handleDatePickerChange(
          new Date(this.DPC.value),
          this.weekCount
      );
      this.reCreateGridColumn(this.DPC.value, this.weekCount);
    }
  }
  handleShiftViewChange = (args: ChangeEventArgs): void => {
  const value = (args.value as ShiftViewMode) || 'default';
  if (value !== this.state.shiftViewMode) {
    localStorage.setItem('CloudSchedularShiftViewMode', value);
    this.setState(
        { shiftViewMode: value },
        () => {
          this.reCreateGridColumn(this.DPC.value, this.weekCount);
        }
    );
  }
};
  render() {
    return (
        <div style={{overflowX: 'auto'}}>

          <div className='time-picker-content'>
            <div className='time-picker-navigate'>
              <FcPrevious
                  size={30}
                  onClick={this.previousWeekButton.bind(this)}
              />
              <DatePickerComponent
                  onChange={this.datePickerOnChange.bind(this)}
                  ref={(el: DatePickerComponent) => (this.DPC = el)}
                  cssClass='e-customStyle'
                  value={this.state.datePickerValue}
                  format={'dd/MM/yyyy'}
                  id='cloudscheduler-load'
                  delayUpdate={true}
                  width={200}
              />
              <FcNext size={30} onClick={this.nextWeekButton.bind(this)} />
              {/* <ButtonComponent
                  onClick={this.handlerOfFitGant.bind(this)}
                  style={{ marginLeft: 10, width: 200 }}
                >
                  Default View
                </ButtonComponent> */}
              <ButtonComponent
                  onClick={ async () => {
                    loadingShow(true);
                    await this.getCapacity(this.props.queryForLoad);
                  }}
                  style={{ marginLeft: 10, width: 100, marginRight: 5 }}
              >
                Refresh
              </ButtonComponent>
              <ChipListComponent
                  id='chip-filter-cp'
                  selectedChips={[0]}
                  selection='Single'
                  // ref={(el: ChipListComponent) => (chips = el)}
                  click={this.handleToChangeWeekNumber.bind(this)}
                  style={{ marginRight: 6 }}
              >
                <ChipsDirective>
                  <ChipDirective
                      text={`1 Week`}
                      cssClass={`e-chip-text1`}
                      key={'1 Week'}
                      value={1}
                  />
                  <ChipDirective
                      text={`2 Week`}
                      cssClass={`e-chip-text2`}
                      key={'2 Week'}
                      value={2}
                  />
                  <ChipDirective
                      text={`3 Week`}
                      cssClass={`e-chip-text3`}
                      key={'3 Week'}
                      value={3}
                  />
                </ChipsDirective>
              </ChipListComponent>
              {/* <ButtonComponent
                  onClick={this.handleToChangeWeekNumber.bind(this, 1)}
                  style={{ marginLeft: 10, width: 200 }}
                >
                  1 Week
                </ButtonComponent>
                <ButtonComponent
                  onClick={this.handleToChangeWeekNumber.bind(this, 2)}
                  style={{ marginLeft: 10, width: 200 }}
                >
                  2 Week
                </ButtonComponent>
                <ButtonComponent
                  onClick={this.handleToChangeWeekNumber.bind(this, 3)}
                  style={{ marginLeft: 10, width: 200 }}
                >
                  3 Week
                </ButtonComponent> */}
              <DropDownListComponent
                  id='shift-view-dropdown'
                  dataSource={this.shiftViewOptions}
                  fields={{ text: 'text', value: 'value' }}
                  value={this.state.shiftViewMode}
                  change={this.handleShiftViewChange}
                  width={152}
                  cssClass='shift-view-dropdown'
                  style={{ marginLeft: 0 }}
              />
            </div>
          </div>

          <div className={`grid-scheduler-load-wrapper ${(this.state.shiftViewMode === 'all' || this.state.shiftViewMode === 'all_no_total') ? 'shift-view-active' : ''} ${(this.state.shiftViewMode === 'day' || this.state.shiftViewMode === 'night') ? 'single-shift-view-active' : ''}`}>
            <GridComponent
                queryCellInfo={this.handleShiftCellMerge}
                rowDataBound={this.handleLoadRowDataBound}
                id='grid-scheduler-load'
                dataSource={this.state.loadGant}
                ref={(g: GridComponent) => (this.theLoadGrid = g)}
                filterSettings={this.FilterOptions}
                // created={this.componentCreated.bind(this)}
                pageSettings={{
                  pageSize: 100,
                  pageCount: 10,
                }}
                style={{
                  marginTop: '10px',
                  overflow: 'hidden',
                }}
                gridLines='Both'
                height={210}
                allowResizing={true}
                dataBound={(args: any) => {
                  if (this.theLoadGrid) {
                    this.theLoadGrid.height = '210';
                  }
                  if (this._pendingLoadScrollRestore !== null) {
                    const contentEl = this.theLoadGrid?.getContent?.()?.firstElementChild as HTMLElement |                undefined;
                    if (contentEl) {
                      contentEl.scrollTop = this._pendingLoadScrollRestore;
                    }
                    this._pendingLoadScrollRestore = null;
                  }
                }}
                frozenColumns={1}
                //frozenRows={1}
                enableHover={false}
                created ={this.componentCreated.bind(this)}
            >
              <ColumnsDirective>
                <ColumnDirective
                    field={'resourceName'}
                    headerText={'Trade'}
                    width='150'
                    isPrimaryKey={true}
                    freeze='Left'
                    textAlign='Right'
                />
                <ColumnDirective
                    field={'totalCapacity'}
                    headerText={'Total Capacity'}
                    freeze='Right'
                    textAlign='Right'
                />
              </ColumnsDirective>
              <Inject
                  services={[
                    ContextMenu,
                    VirtualScroll,
                    Reorder,
                    Page,
                    Resize,
                    ColumnChooser,
                    Freeze,
                    Tooltip,
                  ]}
              />
            </GridComponent>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  cloudSchedularGantDataChanged: state.search.cloudSchedularGantDataChanged,
});

const mapDispatchToProps = (dispatch: any) => ({
  setfilterConfirmation: (value: boolean) =>
      dispatch(setCloudSchedularGantDataChanged(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Load);
